export const projectCategories = {
    scraping: [
        {
            id: "bayut",
            title: "Bayut Property Scraping",
            description:
                "Advanced web scraping solution for real estate data aggregation from Bayut platform",
            metric: "780,000+ records · 3 weeks labor saved per cycle",
            category: "Web Scraping",
            technologies: ["Python", "BeautifulSoup", "Selenium"],
            image: "/pictures/pattern.svg",
            path: "/case-studies/scraping/bayut",
        },
        {
            id: "cars-in-usa",
            title: "Automotive Data Intelligence",
            description:
                "Comprehensive web scraping solution for automotive market analysis across 90+ platforms",
            metric: "250K+ daily records · 90+ marketplaces · 7 months manual work removed",
            category: "Web Scraping",
            technologies: ["Python", "Requests", "Pandas"],
            image: "/pictures/pattern.svg",
            path: "/case-studies/scraping/cars-in-usa",
        },
        {
            id: "facebook-marketplace",
            title: "Facebook Marketplace Scraping",
            description:
                "Continuous marketplace tracking with 15-minute keyword polling and item-level trend analytics",
            metric: "15-min polling · 4 captures/hr per keyword · first-seen → sold tracking",
            category: "Web Scraping",
            technologies: ["Python", "Selenium", "PostgreSQL", "Redis"],
            image: "/pictures/pattern.svg",
            path: "/case-studies/scraping/facebook-marketplace",
        },
        {
            id: "saudi-traffic-intelligence",
            title: "Saudi Traffic Flow Intelligence",
            description:
                "Hourly live traffic collection and route-level time-series analytics across Riyadh, Jeddah, Medina, and Dubai.",
            metric: "4 cities · hourly snapshots 24/7 · inter- and intra-city routes",
            category: "Web Scraping",
            technologies: ["Python", "HERE API", "Google Cloud"],
            image: "/pictures/pattern.svg",
            path: "/case-studies/scraping/saudi-traffic-intelligence",
        },
    ],
    ai: [
        {
            id: "ai-roi-automation",
            title: "Marketing ROI Automation",
            description:
                "Automated 15-minute ROI reporting across Google Ads, TikTok Ads, Facebook Ads, and Ringba metrics for faster media-buying decisions—part of end-to-end ad ops spanning spend, creatives, and scripts.",
            metric: "3 hrs/day manual reporting → 15-min automated cadence",
            category: "AI & Machine Learning",
            technologies: ["Make.com", "Node.js", "Ringba API", "Google Ads", "Slack"],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/media-roi-automation",
        },
        {
            id: "n8n-blog-seo-aeo-automation",
            title: "N8N SEO Blog Automation",
            description:
                "Automated daily SEO and AEO blog discovery, drafting, human review, and WordPress publishing for brand content scale.",
            metric: "3–4 hrs/day VA saved · up to 100 drafts/day · 10 blogs monitored",
            category: "AI & Machine Learning",
            technologies: ["n8n", "WordPress REST API", "AI Writing", "Google Search Console"],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/n8n-blog-seo-aeo-automation",
            thumb: "/pictures/home/n8n-blog.webp",
        },
        {
            id: "instagram-meme-account-automation",
            title: "Instagram Meme Account Automation",
            description:
                "Automated meme account growth using n8n, Gemini Nano Banana visuals, Viva Use AI captions, and Gemini Veo 3 video outputs, reaching 5,000 followers in 18 days.",
            metric: "0 → 5,000 followers in 18 days · 100% automated posting",
            category: "AI & Machine Learning",
            technologies: ["n8n", "Instagram API", "Gemini Nano Banana", "Veo 3"],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/instagram-meme-account-automation",
            thumb: "/pictures/home/social-automation.webp",
        },
        {
            id: "competition-spy-automation",
            title: "Competition Spy Automation",
            description:
                "AI competition intelligence for media buyers that scrapes and ranks winning ads from Facebook Ads Library, SpyHero, and upload-signal platforms, then delivers curated daily trend packs to Slack.",
            metric: "300 videos/day to Slack · $6M/year creative scaling unlocked",
            category: "AI & Machine Learning",
            technologies: [
                "Node.js",
                "Facebook Ads Library",
                "Spy Hero",
                "Competitive Scraping",
                "Slack API",
            ],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/competition-spy-automation",
            thumb: "/pictures/home/competition-spy.webp",
        },
        {
            id: "policy-pdf-annotation",
            title: "AI Policy PDF Annotation",
            description:
                "Automated policy PDF ingestion for TANF, SNAP, Medicare, and Medicaid forms using PDF parsing and multi-LLM validation for structured JSON field annotations.",
            metric: "4× VA workload replaced/mo · 99.4% peak annotation accuracy",
            category: "AI & Machine Learning",
            technologies: ["Python", "pdf-parse", "LLM", "JSON Schema", "OCR"],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/policy-pdf-annotation",
        },
        {
            id: "policy-pdf-fill-conversion",
            title: "AI U.S. Government Benefits PDF Fill Conversion",
            description:
                "Converted U.S. government benefits PDFs (including TANF, SNAP, Medicare, Medicaid, and subsidy workflows) to structured JSON and web-fillable forms, scaling to 1,000+ documents per day while saving 200+ manual hours.",
            metric: "1,000+ PDFs/day · 200+ manual hours saved",
            category: "AI & Machine Learning",
            technologies: ["Python", "pdf-parse", "LLM Ensemble", "JSON Schema", "Fill Engine"],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/policy-pdf-fill-conversion",
            thumb: "/pictures/home/policy-pdf.webp",
        },
        {
            id: "fleetoptics-address-detection",
            title: "AI Detection of Address for Fleetoptics",
            description:
                "Automated delivery address verification using AI to extract house/street numbers from photos and match them against company records in near real time.",
            metric: "77.4% accuracy on 15,000+ images · 2 months to production",
            category: "AI & Machine Learning",
            technologies: ["PaddleOCR", "Google OCR", "Tesseract", "YOLO", "Ensemble Models", "API Integration"],
            image: "/pictures/ai.webp",
            ogImage: "/pictures/og/fleetoptics-address-detection.png",
            path: "/case-studies/ai/fleetoptics-address-detection",
            thumb: "/pictures/home/fleetoptics.webp",
        },
        {
            id: "youtube-summarizer",
            title: "AI YouTube Summarizer",
            description:
                "A real-time Discord-triggered YouTube workflow that handles 50+ daily uploads, transcribes 2+ hours of content, and posts AI summaries to Discord.",
            metric: "50+ uploads/day · 2+ hrs transcribed · manual watch time removed",
            category: "AI & Machine Learning",
            technologies: ["FFmpeg", "OpenAI Whisper", "OpenAI LLM", "Discord API", "Monitoring"],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/youtube-summarizer",
        },
        {
            id: "substack-summarizer",
            title: "Substack Summarizer",
            description:
                "A Node.js-powered monitoring and summarization pipeline for Substack, using cookie-based authentication, 24/7 scraping, and LLM-generated actionable summaries.",
            metric: "7–8 posts/day summarized · up to 100/hr capacity · 24/7 monitoring",
            category: "AI & Machine Learning",
            technologies: ["Node.js", "Web Scraping", "Cookies Auth", "LLMs", "Automation"],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/substack-summarizer",
        },
        {
            id: "social-data-fetcher",
            title: "Auto X / Discord / Telegram Fetcher",
            description:
                "24/7 unofficial API-like scrapers that collect messages from selected X profiles, Discord channels, and Telegram groups, then route them to a Supabase-backed CRM and admin panel.",
            metric: "3,000+ messages/day · 3 platforms · 24/7 harvest",
            category: "AI & Machine Learning",
            technologies: ["Node.js", "Scraping", "Supabase", "Discord Bot", "CRM Integration"],
            image: "/pictures/ai.webp",
            path: "/case-studies/ai/social-data-fetcher",
        },
    ],
    "product-engineering": [
        {
            id: "manzil-delivery-platform",
            title: "Manzil Delivery Platform",
            description:
                "Kuwait multi-sided delivery OS: admin command center, merchant portal, driver app (web + native), and fleet-company portal—orders, wallets, chat, and PostGIS live tracking in one stack.",
            metric: "4 apps · real-time dispatch + live map · EN/AR RTL · KWD wallet ops",
            category: "Product Engineering",
            technologies: [
                "React",
                "React Native",
                "Node.js",
                "PostGIS",
                "Socket.io",
                "MyFatoorah",
            ],
            image: "/pictures/case-studies/manzil/02-admin-live-map.webp",
            path: "/case-studies/product-engineering/manzil-delivery-platform",
            thumb: "/pictures/case-studies/manzil/02-admin-live-map.webp",
        },
        {
            id: "mehfil-media",
            title: "Mehfil Media",
            description:
                "AI UGC SaaS for Pakistani brands: upload a product photo, cast an AI creator, and generate Reel campaigns—live at mehfil-media.jamilglobal.com.",
            metric: "48h photo → pack · 30+ cuts/product · 689K likes on featured Reel",
            category: "Product Engineering",
            technologies: [
                "AI UGC",
                "React",
                "Product Upload SaaS",
                "Video Generation",
                "Urdu / Desi UX",
            ],
            image: "/pictures/ai.webp",
            path: "/case-studies/product-engineering/mehfil-media",
            thumb: "/pictures/case-studies/mehfil-media/12-dashboard.webp",
        },
        {
            id: "ilmora",
            title: "Ilmora",
            description:
                "An AI learning infrastructure platform by Jamil Global that is fully white-labeled, institution-owned, and tailored for schools, colleges, and universities.",
            metric: "100% white-label · 3 roles · K-12 → higher ed",
            category: "Product Engineering",
            technologies: ["Next.js", "LMS Integration", "AI Tutor", "Institutional Branding"],
            image: "/pictures/ai.webp",
            path: "/case-studies/product-engineering/ilmora",
            thumb: "/pictures/case-studies/ilmora/01-marketing-hero.webp",
        },
        {
            id: "spying-agent",
            title: "Spying Agent",
            description:
                "An AI-powered advertising script engine that learns from winning competitor ads and generates unlimited, brand-adapted scripts tuned for tone, niche, and performance.",
            metric: "~200 videos/day ideation feed · ~2 hrs/day saved · $3M→$11M revenue range",
            category: "Product Engineering",
            technologies: ["OpenAI LLM", "Facebook Ads Library", "Google Transparency Center", "Data Scraping", "Prompt Engineering"],
            image: "/pictures/ai.webp",
            path: "/case-studies/product-engineering/spying-agent",
            thumb: "/pictures/case-studies/spying-agent/01-home-hero.webp",
        },
        {
            id: "shakl",
            title: "Shakl",
            description:
                "AI influencer SaaS: create and approve a model from prompt or image, generate 20–100 stills, scrape weekly TikTok viral dances into Instagram Reels with AI captions and text overlays, plus Stripe, affiliates, and admin.",
            metric: "20–100 stills per model · weekly TikTok → Reels pipeline",
            category: "Product Engineering",
            technologies: [
                "AI Image Generation",
                "AI Video Generation",
                "TikTok Scraper",
                "Instagram API",
                "Stripe",
                "Affiliates",
            ],
            image: "/pictures/ai.webp",
            path: "/case-studies/product-engineering/shakl",
            thumb: "/pictures/home/shakl.webp",
        },
        {
            id: "kitty-care",
            title: "Kitty Care",
            description:
                "An AI-powered cat care assistant focused on fast, practical veterinary and wellness conversations with responsive front-end design.",
            metric: "200 chats/day peak · 24/7 · 3 care modes",
            category: "Product Engineering",
            technologies: ["Next.js", "React", "Node.js", "OpenAI API"],
            image: "/pictures/ai.webp",
            path: "/case-studies/product-engineering/kitty-care",
        },
    ],
    "front-end": [
        {
            id: "onetwotrail",
            title: "OneTwoTrail",
            description:
                "Costa Rica travel platform: consumer discovery, trails, and Pass at onetwotrail.com, plus a business portal for operators at business.onetwotrail.com.",
            metric: "2 portals · web + iOS/Android · 1M+ tourist market",
            category: "Front-End Engineering",
            technologies: [
                "Travel Marketplace",
                "React",
                "Maps & Nearby",
                "Itineraries",
                "Business Portal",
            ],
            image: "/pictures/ai.webp",
            path: "/case-studies/front-end/onetwotrail",
            thumb: "/pictures/case-studies/onetwotrail/01-discover.webp",
        },
        {
            id: "pet-heal",
            title: "PetHeal",
            description:
                "The petheal.com storefront: vet-formulated mushroom supplements for dogs and cats, with subscriptions, video testimonials, reviews, and mobile-first checkout.",
            metric: "1.5M+ dogs in community messaging · 3,500+ five-star reviews",
            category: "Front-End Engineering",
            technologies: ["E-commerce", "Responsive UI", "Subscriptions", "Trust & reviews"],
            image: "/pictures/ai.webp",
            path: "/case-studies/front-end/pet-heal",
            thumb: "/pictures/case-studies/petheal/01-home-hero.webp",
        },
        {
            id: "threejs-unleashed",
            title: "Three.js — Unleashed",
            description:
                "A live WebGL laboratory: cinematic scroll worlds, god-mode material labs, and typographic gravity built with React Three Fiber.",
            metric: "3 live WebGL labs · React Three Fiber + GLSL",
            category: "Front-End Engineering",
            technologies: ["Three.js", "React Three Fiber", "GLSL", "Motion"],
            image: "/pictures/ai.webp",
            path: "/case-studies/front-end/threejs-unleashed",
        },
    ],
};
